import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import ProductCard from "web/react/components/product-card/product-card";
import Rail from "web/react/components/rail/rail";
import { ProductCardPropType } from "web/types/product-card";
import styles from "./product-rail.module.css";

function ProductRail({
    className,
    hiddenProductsCount,
    label,
    products,
    title,
    viewMoreUrl,
    railClassName,
    features,
    type,
    id,
    imageSize,
}) {
    let leftButtonStyle = "";
    let rightButtonStyle = "";

    if (type == "homepage") {
        leftButtonStyle = clsx(styles.scrollButton, styles.left);
        rightButtonStyle = clsx(styles.scrollButton, styles.right);
    }

    return (
        <Rail
            analyticsLabel={label}
            className={className}
            peekingCard={features.uj_peeking_card}
            railClassName={railClassName}
            seeAllLink={viewMoreUrl}
            title={title}
            titlePosition="center"
            leftButtonStyle={leftButtonStyle}
            rightButtonStyle={rightButtonStyle}
            id={id}
        >
            {products.map((product, index) => {
                return (
                    <ProductCard
                        className={clsx(styles.productCard, {
                            [styles.largeProductCard]: type == "homepage",
                        })}
                        key={product.id}
                        product={product}
                        hideOnDesktop={index < hiddenProductsCount ? true : false}
                        imageSize={imageSize}
                        scrollParentId={id}
                    />
                );
            })}
        </Rail>
    );
}

ProductRail.propTypes = {
    className: PropTypes.string,
    features: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string])),
    railClassName: PropTypes.string,
    hiddenProductsCount: PropTypes.number,
    label: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(ProductCardPropType).isRequired,
    title: PropTypes.string.isRequired,
    viewMoreUrl: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.string,
    imageSize: PropTypes.string,
};

export default ProductRail;
